<div class="slider-horizontal-container" #container
     (click)="handleClick()"
     (mousedown)="onMouseDown()"
     (mouseup)="onMouseUp()"
     (mouseleave)="onMouseUp()">
  <div *ngIf="!isMobile && formattedElements.length > 1 && activeEl > 0"
       class="click-zone click-zone-left"
       (click)="scrollToElementSwipe('left')">
  </div>
  <div *ngIf="!isMobile && formattedElements.length > 1 && activeEl < formattedElements.length - 1"
       class="click-zone click-zone-right"
       (click)="scrollToElementSwipe('right')">
  </div>
  <div class="slide-points" *ngIf="showPoints()">
    <div *ngFor="let point of formattedElements; let i = index">
      <div class="point"
           [class.point-active]="i === activeEl"
           (click)="goToSlide(i)">
      </div>
    </div>
  </div>
  <div class="slider-container" #movableElement
       [style]="isMobile ? 'overflow: hidden' : ''"
       (mousedown)="startDrag($event)"
       (mouseup)="endDrag($event)"
       (mouseleave)="endDrag($event)"
       (touchstart)="startDrag($event)"
       (touchend)="endDrag($event)"
       (touchmove)="onTouchMove($event)"
       (wheel)="onWheel($event)"
       (scroll)="onScroll($event)">
    <div *ngFor="let el of formattedElements; index as i"
         class="slider"
         [style]="setSliderStyles()">
      <app-about-el [el]="formattedElements[i]"/>
    </div>
  </div>
</div>
